import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { isNumber, max } from 'lodash'

import { FormattedNumber } from '@10xLabs/react-web/components/FormattedNumber'
import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { ORDER_TYPE } from 'features/Inventories/components/OrderType/constants'
import { containersMessages } from 'features/Snacks/components/Containers/messages'
import { safeFormatMessage } from 'utils/intl'

const ItemUnit = styled.span<TSFixMe>`
  white-space: nowrap;
`

export const OrderItems = ({ order }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const [isModalOpen, setModalOpen] = useState(false)

  const isPurchase = order.type === ORDER_TYPE.PURCHASE

  return (
    <div>
      {order.lineItems.length > 0 ? (
        <div>
          <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{order.lineItems.length}</StyledLink>
        </div>
      ) : (
        0
      )}

      {isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): TSFixMe => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="spanish.inventories.orders.items.title" defaultMessage="Productos" />
            </Heading.H5>
          </Modal.Header>

          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />
                    </Th>

                    <Th>
                      <FormattedMessage id="spanish.dictionary.container" defaultMessage="Envase" />
                    </Th>

                    {isPurchase ? (
                      <Th>
                        <FormattedMessage
                          id="spanish.inventories.orders.items.list.quantity"
                          defaultMessage="Cantidad"
                        />
                      </Th>
                    ) : (
                      <>
                        <Th>
                          <FormattedMessage id="spanish.inventories.orders.items.list.sent" defaultMessage="Enviado" />
                        </Th>

                        <Th>
                          <FormattedMessage
                            id="spanish.inventories.orders.items.list.received"
                            defaultMessage="Recibido"
                          />
                        </Th>

                        <Th>
                          <FormattedMessage
                            id="spanish.inventories.orders.items.list.missing"
                            defaultMessage="Faltante"
                          />
                        </Th>

                        <Th>
                          <FormattedMessage
                            id="spanish.inventories.orders.items.list.surplus"
                            defaultMessage="Sobrante"
                          />
                        </Th>
                      </>
                    )}
                  </Tr>
                </Thead>

                <Tbody>
                  {order.lineItems.map((item: TSFixMe, index: TSFixMe): TSFixMe => {
                    return (
                      <Tr key={index}>
                        <Td>{item.name}</Td>

                        <Td>
                          <FormattedMessage
                            id="spanish.items.list.container.value"
                            defaultMessage="{container} de {netContent}"
                            values={{
                              container: safeFormatMessage({ intl, messages: containersMessages, key: item.container }),
                              netContent: (
                                <ItemUnit>
                                  <FormattedNumber value={item.netContent} /> {item.units}
                                </ItemUnit>
                              )
                            }}
                          />
                        </Td>

                        <Td>
                          <FormattedNumber value={item.ordered} />
                        </Td>

                        {!isPurchase && (
                          <>
                            <Td>
                              <FormattedNumber value={item.received} />
                            </Td>

                            <Td>
                              {isNumber(item.received) ? (
                                <FormattedNumber value={max([0, item.ordered - item.received])} />
                              ) : (
                                'N/A'
                              )}
                            </Td>

                            <Td>
                              {isNumber(item.received) ? (
                                <FormattedNumber value={max([0, item.received - item.ordered])} />
                              ) : (
                                'N/A'
                              )}
                            </Td>
                          </>
                        )}
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  )
}
